export const trackInitiateCheckout = _ref => {
  var _checkout$lineItems;
  let {
    checkout
  } = _ref;
  const productsInfo = (_checkout$lineItems = checkout.lineItems) == null ? void 0 : _checkout$lineItems.map(item => {
    var _item$catalogReferenc, _item$productName, _item$productName2, _item$lineItemPrice;
    return {
      id: (_item$catalogReferenc = item.catalogReference) == null ? void 0 : _item$catalogReferenc.catalogItemId,
      name: ((_item$productName = item.productName) == null ? void 0 : _item$productName.translated) ?? ((_item$productName2 = item.productName) == null ? void 0 : _item$productName2.original),
      category: 'All Products',
      price: (_item$lineItemPrice = item.lineItemPrice) == null ? void 0 : _item$lineItemPrice.amount,
      currency: checkout.currency,
      quantity: item == null ? void 0 : item.quantity
    };
  });
  return ['InitiateCheckout', {
    contents: productsInfo,
    origin: 'Stores'
  }];
};
//# sourceMappingURL=analytics.utils.js.map